import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as Settings } from 'store/ducks/settings';

import { Form, Loading } from 'components';

class SettingForm extends Component {
  state = {
    data: this.props.data,
  };

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { onChange } = this.props;

    if (oldProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleChangeInput = e => {
    const { value, name } = e.target;
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  render() {
    const { data } = this.state;
    const { errors, saving, onSubmit } = this.props;

    return (
      <Form className="page-form">
        <h3 className="form-title">Variáveis</h3>

        <Form.Field>
          <Form.Label>Nome</Form.Label>
          <Form.Input
            name="name"
            placeholder="Nome"
            value={data.name}
            errors={errors.name}
            onChange={this.handleChangeInput}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Descrição</Form.Label>
          <Form.Input
            name="description"
            placeholder="Descrição"
            value={data.description}
            errors={errors.description}
            onChange={this.handleChangeInput}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Valor</Form.Label>
          <Form.Input
            name="value"
            placeholder="Alias"
            value={data.value}
            errors={errors.value}
            onChange={this.handleChangeInput}
          />
        </Form.Field>

        <div className="buttons">
          <Link to="/configs/settings" className="button-cancel">
            Cancelar
          </Link>

          <Form.Button className="button-save" onClick={onSubmit} disabled={saving}>
            {saving ? <Loading type="btn" size="small" text="Salvando..." /> : 'Salvar'}
          </Form.Button>
        </div>
      </Form>
    );
  }
}

const mapActions = dispatch => bindActionCreators(Settings, dispatch);

export default connect(
  null,
  mapActions,
)(SettingForm);
